let customCss: string | null = null;

export const setCustomCss = (value: string) => {
  customCss = value;
};

export const getCustomCss = (): string | null => {
  return customCss;
};